import React from "react";
import { eyeIcon, LibraryIcon } from "@excalidraw/excalidraw/components/icons";
import { useExcalidrawSetAppState } from "@excalidraw/excalidraw/components/App";
import { trackEvent } from "@excalidraw/excalidraw/analytics";
import { DEFAULT_SIDEBAR } from "@excalidraw/excalidraw/constants";

import type { Theme } from "@excalidraw/excalidraw/element/types";
import { MainMenu } from "@excalidraw/excalidraw/index";
import { LanguageList } from "../app-language/LanguageList";
import { saveDebugState } from "./DebugCanvas";

export const AppMainMenu: React.FC<{
  theme: Theme | "system";
  setTheme: (theme: Theme | "system") => void;
  refresh: () => void;
}> = React.memo((props) => {
  const setAppState = useExcalidrawSetAppState();

  return (
    <MainMenu>
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.SaveAsImage />
      <MainMenu.Item
        icon={LibraryIcon}
        onSelect={() => {
          trackEvent("board", "open-my-boards");
          setAppState({
            openSidebar: { name: DEFAULT_SIDEBAR.name, tab: "my-boards" },
          });
        }}
      >
        Мои доски
      </MainMenu.Item>

      <MainMenu.Separator />

      <MainMenu.DefaultItems.ClearCanvas />
      {import.meta.env.DEV && (
        <MainMenu.Item
          icon={eyeIcon}
          onClick={() => {
            if (window.visualDebug) {
              delete window.visualDebug;
              saveDebugState({ enabled: false });
            } else {
              window.visualDebug = { data: [] };
              saveDebugState({ enabled: true });
            }
            props?.refresh();
          }}
        >
          Visual Debug
        </MainMenu.Item>
      )}
      <MainMenu.Separator />
      <MainMenu.DefaultItems.ToggleTheme
        allowSystemTheme
        theme={props.theme}
        onSelect={props.setTheme}
      />
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
    </MainMenu>
  );
});